
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetokonkandarshan() {



    const cardData =
    {
        keyword: 'Pune to Konkan Darshan Bus Hire',
        heading: 'Amruta Travels: Pune to Konkan Darshan Bus Hire',
        headingDescription: 'Amruta Travels offers Pune to Konkan Darshan Bus Hire, providing a scenic and comfortable travel experience to explore the stunning beauty of the Konkan region. Whether it’s a coastal vacation, heritage tour, family trip, or religious journey, our well-maintained buses make your ride through the winding Konkan roads smooth and enjoyable. Choose from our fleet of 17-seater, 32-seater, and 50-seater buses, all equipped with modern amenities and driven by skilled drivers familiar with the coastal routes. With timely service, affordable pricing, and 24/7 support, Amruta Travels ensures your Pune to Konkan Darshan trip is memorable, safe, and full of discovery. Book your bus today and explore the charm of Konkan!',


        top: 'Top Places to Visit in Konkan with Amruta Travels',
"topPlaces": [
  {
    "title": "Ganpatipule",
    "description": "A serene coastal town known for its pristine beaches and the revered Swayambhu Ganpati Temple. Ganpatipule offers a blend of natural beauty and spiritual significance, making it a popular destination for pilgrims and beach lovers alike."
  },
  {
    "title": "Alibaug",
    "description": "A coastal town famous for its clean beaches, historic forts like Kolaba Fort, and proximity to Mumbai. Alibaug is a favored weekend getaway offering a mix of relaxation and adventure."
  },
  {
    "title": "Ratnagiri",
    "description": "Known for its Alphonso mangoes, Ratnagiri boasts beautiful beaches, ancient forts, and the birthplace of freedom fighter Lokmanya Tilak. It's a blend of cultural heritage and natural beauty."
  },
  {
    "title": "Sindhudurg",
    "description": "Home to the majestic Sindhudurg Fort built by Shivaji Maharaj, this region offers historical insights and scenic beaches, making it a must-visit for history enthusiasts."
  },
  {
    "title": "Dapoli",
    "description": "Often referred to as 'Mini Mahabaleshwar', Dapoli is known for its cool climate, beaches, and ancient temples. It's an ideal spot for those seeking tranquility away from bustling cities."
  },
  {
    "title": "Tarkarli",
    "description": "Famous for its crystal-clear waters and coral reefs, Tarkarli is a hotspot for water sports like scuba diving and snorkeling. The nearby Sindhudurg Fort adds a historical touch to the visit."
  },
  {
    "title": "Murud",
    "description": "A picturesque town known for the formidable Murud-Janjira Fort situated on an island. The town's beaches and historical significance attract numerous tourists."
  },
  {
    "title": "Harnai",
    "description": "A quaint fishing village offering fresh seafood, serene beaches, and the historic Suvarnadurg Fort. Harnai provides an authentic Konkan coastal experience."
  },
  {
    "title": "Mahad",
    "description": "A town of historical importance, Mahad is known for the Gandharpale Caves and the Raigad Fort, which was the capital of Shivaji Maharaj's kingdom."
  },
  {
    "title": "Amboli",
    "description": "A hill station nestled in the Sahyadri Hills, Amboli is renowned for its waterfalls, misty landscapes, and rich biodiversity, making it a haven for nature enthusiasts."
  }
],



   "services": [
    {
      "name": "Pune to Konkan Darshan Tempo Traveller Package",
      "description": "Explore the scenic beauty of Konkan with Amruta Travels' Tempo Traveller package from Pune. Ideal for families and small groups, our AC Tempo Travellers offer a comfortable ride through coastal destinations like Ratnagiri, Devgad, and Diveagar with customizable itinerary options and experienced drivers."
    },
    {
      "name": "Mini Bus On Rent in Ratnagiri",
      "description": "Hire well-maintained mini buses in Ratnagiri for local sightseeing, picnics, or return journeys. Amruta Travels offers 17 to 27-seater AC and Non-AC buses at competitive rates with skilled drivers who know the Konkan routes well."
    },
    {
      "name": "Pune to Palghar Bus on Rent",
      "description": "Travel from Pune to Palghar with our reliable bus rental services. Amruta Travels offers buses with various seating capacities for family outings, business visits, or religious trips to this coastal town in north Konkan."
    },
    {
      "name": "Pune to Raigad Darshan Bus on Rent",
      "description": "Book a dedicated bus from Pune to Raigad Fort for historical tours or educational trips. Our buses are ideal for groups visiting this iconic Maratha site, offering safe transport with experienced drivers and flexible pickup points."
    },
    {
      "name": "Pune to Sindhudurg Bus Hire for Picnic",
      "description": "Plan a beachside getaway or heritage tour with Amruta Travels' bus rental from Pune to Sindhudurg. Our spacious and clean buses are great for school trips, family tours, and weekend picnics across Konkan’s coastal gems."
    },
    {
      "name": "Pune to Konark Bus Hire for Picnic",
      "description": "Visit the architectural marvels and beaches of Konark with our picnic bus rental services from Pune. Amruta Travels provides both AC and Non-AC buses suitable for long-distance travel with large groups."
    },
    {
      "name": "Pune to Imagica Bus Hire for Picnic",
      "description": "Take your group to Imagica Theme Park with Amruta Travels’ picnic bus services. We offer flexible pickup options from Pune and various bus sizes for school, college, or corporate day trips to India’s favorite amusement destination."
    },
    {
      "name": "Pune to Sawantwadi Bus Hire for Picnic",
      "description": "Explore the cultural beauty of Sawantwadi with Amruta Travels' rental services. Our buses are ideal for picnics, temple visits, and Konkan handicraft explorations with comfortable seating and punctual service."
    },
    {
      "name": "Pune to Konkan Darshan Urbania on Rent",
      "description": "Book a premium Force Urbania van for your Konkan Darshan trip from Pune. Perfect for small families or executive group travel, our 13- and 17-seater Urbania vehicles come with luxury features and smooth rides across coastal roads."
    },
    {
      "name": "Pune to Devgad Bus on Rent for Picnic",
      "description": "Enjoy a relaxing picnic in Devgad’s serene beaches and mango orchards with our AC/Non-AC bus rentals from Pune. Amruta Travels ensures safe travel, ample space for luggage, and reliable on-time pickups for all group sizes."
    },
    {
      "name": "Hire Pune to Diveagar Mini Bus & Tempo Traveller on Rent",
      "description": "Head to the peaceful beaches of Diveagar with Amruta Travels’ mini bus and Tempo Traveller rentals. Our vehicles include 14, 17, and 20-seater options, ideal for family outings, weekend getaways, and spiritual visits."
    }
  ],
  "tableData": [
    ["Pune to Konkan Darshan Tempo Traveller Package", "Mini Bus On Rent in Ratnagiri"],
    ["Pune to Palghar Bus on Rent", "Pune to Raigad Darshan Bus on Rent"],
    ["Pune to Sindhudurg Bus Hire for Picnic", "Pune to Konark Bus Hire for Picnic"],
    ["Pune to Imagica Bus Hire for Picnic", "Pune to Sawantwadi Bus Hire for Picnic"],
    ["Pune to Konkan Darshan Urbania on Rent", "Pune to Devgad Bus on Rent for Picnic"],
    ["Hire Pune to Diveagar Mini Bus & Tempo Traveller on Rent", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Scenic and Comfortable Konkan Darshan Travel from Pune",
    "WhyChoosedescription": "Amruta Travels offers Pune to Konkan Darshan Bus Hire, providing a scenic and comfortable way to explore the stunning Konkan coast. Whether you're visiting beaches, temples, forts, or coastal villages, our buses ensure a relaxed journey through lush green landscapes, winding ghats, and coastal roads. Travel in comfort with air-conditioned buses, push-back seats, and experienced drivers who understand the route well."
  },
  {
    "WhyChooseheading": "Perfect for Family Trips, Pilgrimages, and Group Tours",
    "WhyChoosedescription": "Our Pune to Konkan Darshan bus rentals are ideal for family vacations, school trips, spiritual yatras, or group sightseeing tours. Whether you're heading to Ganpatipule, Tarkarli, Malvan, Sindhudurg, or Ratnagiri, we provide buses in all sizes—from 17-seaters to 50-seaters—ensuring your entire group can travel together comfortably, safely, and affordably."
  },
  {
    "WhyChooseheading": "Well-Planned Routes Covering Popular Konkan Attractions",
    "WhyChoosedescription": "We help you design a customized Konkan Darshan itinerary that includes major attractions like Ganpatipule Temple, Devgad Beach, Sindhudurg Fort, Tarkarli Water Sports, and the scenic coastal drives. You can also include cultural stops and local food experiences. Our team ensures you get a well-paced, enjoyable, and spiritually/culturally enriching journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Coastal and Ghat Routes",
    "WhyChoosedescription": "Driving through the Konkan region requires experience and skill due to winding ghats and narrow coastal roads. Our trained drivers are familiar with the terrain and ensure safe, smooth, and punctual travel. With a calm and courteous attitude, they assist your group throughout the journey, making it enjoyable and stress-free."
  },
  {
    "WhyChooseheading": "Affordable Packages for Multi-Day Tours",
    "WhyChoosedescription": "We offer cost-effective and transparent pricing for multi-day Pune to Konkan Darshan trips. Our rental packages are flexible, covering travel, halt time, driver allowance, and fuel. There are no hidden fees, and we work with your budget to provide you with the best value. Whether it's a 2-day weekend tour or a 5-day coastal trip, we’ve got you covered."
  },
  {
    "WhyChooseheading": "Clean, Air-Conditioned Buses with Ample Luggage Space",
    "WhyChoosedescription": "Our fleet of buses is regularly serviced and sanitized for your comfort and safety. With features like air conditioning, clean seat covers, large windows, and storage space for luggage, your group can enjoy long drives across the Konkan stretch in total comfort. We also provide non-AC options for those seeking budget-friendly travel."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop Locations in Pune and Konkan",
    "WhyChoosedescription": "We provide door-to-door service with customizable pickup and drop points anywhere in Pune and Konkan. Whether you're a school group, company team, or family trip organizer, we coordinate pickup from your exact location in Pune and drop you off at your resort, temple, or homestay in the Konkan region."
  },
  {
    "WhyChooseheading": "Easy Booking with Itinerary Assistance and Support",
    "WhyChoosedescription": "Booking your Pune to Konkan Darshan Bus Hire is simple and fast. You can reserve your bus online, by phone, or by visiting our office. Our support team assists with route planning, destination suggestions, and customizing your schedule. From the first inquiry to the final drop-off, we provide end-to-end travel support."
  }
]


















    }

const faqData = [
  {
    question: 'How can I hire a bus from Pune to Konkan for a Darshan tour?',
    answer: 'Hiring a bus for Konkan Darshan from Pune with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll help you choose the right bus and plan your coastal pilgrimage or sightseeing tour.',
  },
  {
    question: 'What destinations are covered under the Konkan Darshan tour?',
    answer: 'The Konkan Darshan tour typically includes popular places like Ganpatipule, Ratnagiri, Devgad, Sindhudurg, Tarkarli, and Kunkeshwar. You can customize the route to include religious sites, beaches, forts, and more.',
  },
  {
    question: 'What bus options are available for the Pune to Konkan Darshan trip?',
    answer: 'We offer 32, 35, 40, 45, and 50-seater buses with standard and luxury options. All buses are equipped with push-back seats, AC, ample legroom, and luggage storage—ideal for long-distance travel across Konkan.',
  },
  {
    question: 'How many days is the typical Pune to Konkan Darshan trip?',
    answer: 'The tour usually takes 3 to 5 days depending on the number of destinations and the pace of the journey. We can customize the itinerary based on your group’s preferences.',
  },
  {
    question: 'Are your buses suitable for family groups and elderly travelers?',
    answer: 'Yes, our buses are ideal for family groups and senior citizens. We prioritize comfort, safety, and convenience with professional drivers and frequent rest stops.',
  },
  {
    question: 'How much does it cost to hire a bus for a Konkan tour from Pune?',
    answer: 'Pricing depends on the bus size, number of travel days, route, and services required. Contact us with your itinerary for a detailed and customized quote.',
  },
  {
    question: 'Do you provide round-trip and one-way options?',
    answer: 'Yes, we provide flexible booking options including one-way, round-trip, and multi-day packages. Let us know your travel dates and requirements for the best deal.',
  },
  {
    question: 'Are your buses sanitized and well-maintained?',
    answer: 'Absolutely. All our buses undergo routine maintenance and are thoroughly cleaned and sanitized before every journey for passenger safety and hygiene.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Konkan Darshan bus hire?',
    answer: 'Amruta Travels is a trusted name for coastal and pilgrimage group tours. We offer reliable service, experienced drivers, comfortable buses, and customized routes to make your Konkan journey memorable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vijay Khot',
    role: 'Tour Organizer, Pune',
    text: 'We arranged a 4-day Konkan Darshan tour using a 45-seater bus from Amruta Travels. The experience was smooth and well-managed. Clean bus, courteous driver, and great coordination. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meena Jagtap',
    role: 'Family Trip Planner, Pune',
    text: 'Our family booked a 35-seater bus for a Konkan coastal trip. The service was excellent and the journey was very comfortable. The driver knew the route well and made our darshan stress-free and joyful.',
    rating: 5,
  },
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-konkan-darshan-bus-hire.jpg",
  "description": "Book bus hire packages from Pune to Konkan for darshan, picnics, and sightseeing. Travel to Ratnagiri, Sindhudurg, Palghar, Diveagar, Devgad, Raigad, Sawantwadi, and Imagica with 14 to 50 seater buses, Tempo Travellers, and Urbania. Ideal for family trips, groups, and Konkan tours from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5740"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-konkan-darshan-bus-hire"
  }
};






    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Pune to Konkan Darshan Bus Hire | Ratnagiri, Sindhudurg, Diveagar | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses and Tempo Travellers for Pune to Konkan Darshan trips. Visit Ratnagiri, Sindhudurg, Devgad, Palghar, Raigad, Sawantwadi & Imagica. Ideal for family tours, picnics & group travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokonkandarshan;